import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import VerificationCodeInput from '@/components/VerificationCodeInput'
import { APIWeb } from '@/api'
import { Toast } from 'react-vant'
import { useUserInfo } from '@/hooks'
import { useSendCode } from '@/hooks/useSendCode'

export default React.memo(function VerifyPhoneCode() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { actions: userActions } = useUserInfo()
  const { sendCode, sendCodeLoading } = useSendCode()
  
  // 从路由状态中获取手机号
  const phone = location.state?.phone || ''
  
  const [submitLoading, setSubmitLoading] = useState(false)

  // 处理验证码提交
  const handleSubmit = async (code: string) => {
    if (!phone || !code) {
      Toast.fail(t('请输入验证码'))
      return
    }

    setSubmitLoading(true)
    try {
      await APIWeb.bindPhone({
        phone,
        code
      })
      
      Toast.success({
        message: t('绑定成功'),
        duration: 1500,
        onClose: async () => {
          // 刷新用户信息
          await userActions.refreshUserInfo()
          // 返回首页
          navigate('/home', { replace: true })
        }
      })
    } catch (error) {
      console.error('绑定手机失败:', error)
    } finally {
      setSubmitLoading(false)
    }
  }

  // 重新发送验证码
  const handleResendCode = async () => {
    if (!phone) {
      Toast.fail(t('手机号不能为空'))
      return
    }

    await sendCode({
      account: phone,
      scene: 'bind_phone'
    })
  }

  return (
    <PageLayout tabbarPage={false}>
      <Header
        leftChildren={<Back />}
        centerChildren={<div className="text-3.75 font-medium text-black">{t('验证')}</div>}
      />
      <div className='px-6 py-6'>
        <VerificationCodeInput
          account={phone}
          onSubmit={handleSubmit}
          onResendCode={handleResendCode}
          submitLoading={submitLoading}
          resendLoading={sendCodeLoading}
          submitButtonText={t('确认')}
          title={t('我们刚刚向您发送了验证码')}
          description={t('要登录请输入我们发送至X的安全代码该代码将在10分钟后失效', { account: phone })}
        />
      </div>
    </PageLayout>
  )
})
